import dompurify from "isomorphic-dompurify";

import { Button } from "@jti/core-components/components/Button";
import { useTranslations } from "@jti/ui";

import styles from "./SummaryLoyaltyPoints.module.scss";

const { sanitize } = dompurify;

export enum LOYALTY_CHOICE {
  COLLECT = 0,
  REDEEM = 1,
}

export type SummaryLoyaltyPointsProps = {
  totalLoyaltyPoints: number;
  loyaltyChoice: LOYALTY_CHOICE;
  learnMoreUrl?: string;
};

export const SummaryLoyaltyPoints = ({
  totalLoyaltyPoints,
  loyaltyChoice,
  learnMoreUrl,
}: SummaryLoyaltyPointsProps) => {
  const { __ } = useTranslations();

  if (loyaltyChoice === LOYALTY_CHOICE.COLLECT && totalLoyaltyPoints) {
    return (
      <div className={styles.message}>
        {__("cart.ploom_club.pointsBlock.collect_message", [totalLoyaltyPoints ?? ""])}
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div
        data-testid={"noPointsMessage"}
        dangerouslySetInnerHTML={{
          __html: sanitize(__("loyalty.checkout.noPointsMessage")),
        }}
        className={styles.message}
      />
      {learnMoreUrl ? (
        <Button variant="text" href={learnMoreUrl} size="sm">
          {__("loyalty.checkout.learnMore")}
        </Button>
      ) : null}
    </div>
  );
};
